import { formatRunDuration, formatRunTimestamp, getRunProgress } from '../../helpers/sisSyncRunDisplay'
import type { ISisSyncRun } from '../../models/SisSyncRun'

// A running run is re-read every 30 s so its progress moves without a reload. The header and the
// files table share it, so they move together.
export const RUNNING_REFETCH_MS = 30000

export interface RunMeta {
  started: string
  // Running only: progress replaces finished and duration, never a bare "Running" (rule 2).
  progress: string | null
  lastProgress: string | null
  finished: string | null
  duration: string | null
}

// The parts of the meta line. The page draws Started and Finished as icons with a hover label, and
// the trigger as a badge beside the status chip, so none of those words are part of the text.
export const getRunMeta = (run: ISisSyncRun): RunMeta => {
  const isRunning = run.outcome === 'RUNNING'
  const currentFile = run.currentFileName != null ? `: ${run.currentFileName}` : ''

  return {
    started: formatRunTimestamp(run.startedOn),
    progress: isRunning ? `${getRunProgress(run)}${currentFile}` : null,
    lastProgress: isRunning && run.lastProgressOn != null ? `Last progress ${formatRunTimestamp(run.lastProgressOn)}` : null,
    finished: !isRunning && run.finishedOn != null ? formatRunTimestamp(run.finishedOn) : null,
    duration: !isRunning && run.durationMs != null ? formatRunDuration(run.durationMs) : null
  }
}
